import { render, staticRenderFns } from "./DodajKontrole.vue?vue&type=template&id=8f74e0f0&"
import script from "./DodajKontrole.vue?vue&type=script&lang=js&"
export * from "./DodajKontrole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports